<template>
  <div
    class="modal fade text-left"
    id="adminEditUserModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="adminEditUserModalLabel"
    aria-hidden="true"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header bg-spnm text-white">
          <h6 class="modal-title" id="adminEditUserModalLabel">
            <i class="fas fa-user-edit mr-2"></i>
            <span v-if="profileForm">{{ profileForm.firstName }} {{ profileForm.lastName }}</span>
            <small class="ml-2 text-light" v-if="profileForm && profileForm.membershipNo">({{ profileForm.membershipNo }})</small>
          </h6>
          <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body custom-scroller" v-if="profileForm">
          <!-- Nav Tabs -->
          <ul class="nav nav-tabs mb-3" role="tablist">
            <li class="nav-item">
              <a class="nav-link active" id="editProfileTab" data-toggle="tab" href="#editProfilePane" role="tab">
                <i class="fas fa-user mr-1"></i>User Profile
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="editMembershipTab" data-toggle="tab" href="#editMembershipPane" role="tab" @click="loadMemberships">
                <i class="fas fa-id-card mr-1"></i>Membership Records
              </a>
            </li>
          </ul>

          <div class="tab-content">

            <!-- ===== TAB 1: USER PROFILE ===== -->
            <div class="tab-pane fade show active" id="editProfilePane" role="tabpanel">
              <form @submit.prevent="saveProfile">
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label>First Name <span class="text-danger">*</span></label>
                    <input v-model="profileForm.firstName" type="text" class="form-control form-control-sm" maxlength="50" required />
                  </div>
                  <div class="form-group col-md-6">
                    <label>Last Name <span class="text-danger">*</span></label>
                    <input v-model="profileForm.lastName" type="text" class="form-control form-control-sm" maxlength="50" required />
                  </div>
                </div>

                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label>Personal Email <span class="text-danger">*</span></label>
                    <input v-model="profileForm.personalEmailId" type="email" class="form-control form-control-sm" maxlength="254" required />
                  </div>
                  <div class="form-group col-md-6">
                    <label>Official Email <span class="text-danger">*</span></label>
                    <input v-model="profileForm.officialEmailId" type="email" class="form-control form-control-sm" maxlength="254" required />
                  </div>
                </div>

                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label>Gender <span class="text-danger">*</span></label>
                    <select v-model="profileForm.gender" class="form-control form-control-sm" required>
                      <option value="">-- Select --</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                    </select>
                  </div>
                  <div class="form-group col-md-6">
                    <label>Birth Date</label>
                    <input v-model="profileBirthDate" type="date" class="form-control form-control-sm" />
                  </div>
                </div>

                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label>Highest Education</label>
                    <input v-model="profileForm.highestEducation" type="text" class="form-control form-control-sm" maxlength="254" />
                  </div>
                  <div class="form-group col-md-6">
                    <label>Industry/Vertical</label>
                    <select v-model="profileForm.industryVertical" class="form-control form-control-sm" @change="onIndustryChange">
                      <option value="">-- Select --</option>
                      <option v-for="v in industryVerticals" :key="v.gpId" :value="v.gpId">{{ v.shortDescription }}</option>
                      <option value="0">Others</option>
                    </select>
                  </div>
                </div>

                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label>Other Industry/Vertical</label>
                    <input
                      v-model="profileForm.otherIndustryVertical"
                      type="text"
                      class="form-control form-control-sm"
                      maxlength="249"
                      :disabled="profileForm.industryVertical != '0' && profileForm.industryVertical !== 0"
                    />
                  </div>
                  <div class="form-group col-md-6">
                    <label>Company Name <span class="text-danger">*</span></label>
                    <input v-model="profileForm.companyName" type="text" class="form-control form-control-sm" maxlength="254" required />
                  </div>
                </div>

                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label>Job Title/Position <span class="text-danger">*</span></label>
                    <input v-model="profileForm.jobTitle" type="text" class="form-control form-control-sm" maxlength="254" required />
                  </div>
                  <div class="form-group col-md-6">
                    <label>Personal Mobile No. <span class="text-danger">*</span></label>
                    <input v-model="profileForm.personalMobileNo" type="text" class="form-control form-control-sm" maxlength="13" required />
                  </div>
                </div>

                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label>Alternative Mobile No.</label>
                    <input v-model="profileForm.alternativeMobileNo" type="text" class="form-control form-control-sm" maxlength="13" />
                  </div>
                  <div class="form-group col-md-6">
                    <label>Membership No.</label>
                    <input v-model="profileForm.membershipNo" type="text" class="form-control form-control-sm" readonly />
                  </div>
                </div>

                <div class="form-group">
                  <label>Preferred Address</label>
                  <textarea v-model="profileForm.address" class="form-control form-control-sm" rows="2" maxlength="999"></textarea>
                </div>

                <div v-if="profileError" class="alert alert-danger py-2"><i class="fas fa-exclamation-circle mr-1"></i>{{ profileError }}</div>
                <div v-if="profileSuccess" class="alert alert-success py-2"><i class="fas fa-check-circle mr-1"></i>{{ profileSuccess }}</div>

                <div class="text-right">
                  <button type="submit" class="btn btn-spnm btn-sm" :disabled="savingProfile">
                    <span v-if="savingProfile"><i class="fas fa-sync-alt fa-spin mr-1"></i>Saving...</span>
                    <span v-else><i class="fas fa-save mr-1"></i>Save Profile</span>
                  </button>
                </div>
              </form>
            </div>

            <!-- ===== TAB 2: MEMBERSHIP RECORDS ===== -->
            <div class="tab-pane fade" id="editMembershipPane" role="tabpanel">

              <div class="d-flex justify-content-between align-items-center mb-3">
                <span class="text-muted" style="font-size:0.85rem;">
                  Membership records for this user.
                </span>
                <button class="btn btn-spnm btn-sm" @click="openMembershipForm(null)">
                  <i class="fas fa-plus mr-1"></i>Add New Membership
                </button>
              </div>

              <!-- Inline membership add/edit form -->
              <div v-if="showMembershipForm" class="card p-3 mb-3 border-primary">
                <h6 class="mb-3 text-primary">
                  <i class="fas fa-id-card mr-1"></i>
                  {{ editingMembership.membershipId ? 'Edit Membership' : 'Add New Membership' }}
                </h6>
                <form @submit.prevent="saveMembership">
                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <label>Membership Type <span class="text-danger">*</span></label>
                      <select v-model="editingMembership.membershipType" class="form-control form-control-sm" required>
                        <option value="">-- Select --</option>
                        <option v-for="plan in membershipPlans" :key="plan.gpId" :value="plan.gpId">{{ plan.shortDescription }}</option>
                      </select>
                    </div>
                    <div class="form-group col-md-6">
                      <label>Status <span class="text-danger">*</span></label>
                      <select v-model="editingMembership.membershipStatus" class="form-control form-control-sm" required>
                        <option value="">-- Select --</option>
                        <option value="Active">Active</option>
                        <option value="InActive">InActive</option>
                      </select>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <label>Valid From <span class="text-danger">*</span></label>
                      <input v-model="editingMembership.validFromInput" type="date" class="form-control form-control-sm" required />
                    </div>
                    <div class="form-group col-md-6">
                      <label>Valid Till <span class="text-danger">*</span></label>
                      <input v-model="editingMembership.validTillInput" type="date" class="form-control form-control-sm" required />
                    </div>
                  </div>
                  <div v-if="membershipFormError" class="alert alert-danger py-2"><i class="fas fa-exclamation-circle mr-1"></i>{{ membershipFormError }}</div>
                  <div v-if="membershipFormSuccess" class="alert alert-success py-2"><i class="fas fa-check-circle mr-1"></i>{{ membershipFormSuccess }}</div>
                  <div class="text-right">
                    <button type="button" class="btn btn-secondary btn-sm mr-2" @click="cancelMembershipForm">Cancel</button>
                    <button type="submit" class="btn btn-spnm btn-sm" :disabled="savingMembership">
                      <span v-if="savingMembership"><i class="fas fa-sync-alt fa-spin mr-1"></i>Saving...</span>
                      <span v-else><i class="fas fa-save mr-1"></i>Save</span>
                    </button>
                  </div>
                </form>
              </div>

              <!-- Membership records list -->
              <div v-if="membershipsLoading" class="text-center py-3">
                <i class="fas fa-sync-alt fa-spin text-primary"></i>
              </div>
              <div v-else-if="memberships.length === 0 && !showMembershipForm" class="text-center text-muted py-3">
                No membership records found.
              </div>
              <div v-for="m in memberships" :key="m.membershipId" class="card p-3 mb-2 shadow-sm">
                <div class="row align-items-center">
                  <div class="col-md-10">
                    <div class="row">
                      <div class="col-md-3">
                        <small class="text-muted">Type</small>
                        <div>{{ m.membershipTypeName || m.membershipType }}</div>
                      </div>
                      <div class="col-md-2">
                        <small class="text-muted">Status</small>
                        <div>
                          <span :class="m.membershipStatus === 'Active' ? 'badge badge-success' : 'badge badge-danger'">
                            {{ m.membershipStatus }}
                          </span>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <small class="text-muted">Valid From</small>
                        <div>{{ formatDate(m.validFrom) }}</div>
                      </div>
                      <div class="col-md-3">
                        <small class="text-muted">Valid Till</small>
                        <div>{{ formatDate(m.validTill) }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-2 text-right">
                    <button class="btn btn-outline-primary btn-sm" @click="openMembershipForm(m)">
                      <i class="fas fa-edit"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="savingProfile || membershipsLoading" class="overlay">
          <i class="fas fa-2x fa-sync-alt fa-spin"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  name: "AdminEditUserModal",
  props: ["userData"],
  data() {
    return {
      profileForm: null,
      profileBirthDate: null,
      savingProfile: false,
      profileError: null,
      profileSuccess: null,
      industryVerticals: [],
      membershipPlans: [],

      memberships: [],
      membershipsLoaded: false,
      membershipsLoading: false,

      showMembershipForm: false,
      editingMembership: this.emptyMembership(),
      savingMembership: false,
      membershipFormError: null,
      membershipFormSuccess: null,
    };
  },
  watch: {
    userData: {
      immediate: true,
      handler(val) {
        if (val) {
          this.profileForm = Object.assign({}, val);
          this.profileBirthDate = val.birthDate
            ? moment(val.birthDate).format("YYYY-MM-DD")
            : null;
          this.profileError = null;
          this.profileSuccess = null;
          this.membershipsLoaded = false;
          this.memberships = [];
          this.showMembershipForm = false;
          this.editingMembership = this.emptyMembership();
        }
      },
    },
  },
  created() {
    this.loadIndustryVerticals();
    this.loadMembershipPlans();
  },
  methods: {
    emptyMembership() {
      return {
        membershipId: 0,
        membershipType: "",
        membershipStatus: "Active",
        validFromInput: moment().format("YYYY-MM-DD"),
        validTillInput: moment().add(1, "years").format("YYYY-MM-DD"),
      };
    },
    loadIndustryVerticals() {
      axios
        .post("/api/GeneralPurpose/GPByGPType", { gpType: "IndustryVertical" })
        .then((resp) => {
          this.industryVerticals = resp.data.generalPurposeItems || [];
        })
        .catch(() => {});
    },
    loadMembershipPlans() {
      axios
        .post("/api/GeneralPurpose/GPByGPType", { gpType: "MembershipType" })
        .then((resp) => {
          this.membershipPlans = resp.data.generalPurposeItems || [];
        })
        .catch(() => {});
    },
    onIndustryChange() {
      this.profileForm.otherIndustryVertical = "";
    },
    loadMemberships() {
      if (this.membershipsLoaded || !this.profileForm) return;
      this.membershipsLoading = true;
      axios
        .post("/api/Membership/UserMembershipsAdmin", { userId: this.profileForm.userId })
        .then((resp) => {
          this.memberships = resp.data || [];
          this.membershipsLoaded = true;
          this.membershipsLoading = false;
          // Resolve membership type names
          this.memberships.forEach((m) => {
            const plan = this.membershipPlans.find((p) => p.gpId === m.membershipType);
            if (plan) m.membershipTypeName = plan.shortDescription;
          });
        })
        .catch(() => {
          this.membershipsLoading = false;
        });
    },
    formatDate(val) {
      return val ? moment(val).format("DD-MMM-YYYY") : "—";
    },
    openMembershipForm(membership) {
      this.membershipFormError = null;
      this.membershipFormSuccess = null;
      if (membership) {
        this.editingMembership = {
          membershipId: membership.membershipId,
          membershipType: membership.membershipType,
          membershipStatus: membership.membershipStatus,
          validFromInput: moment(membership.validFrom).format("YYYY-MM-DD"),
          validTillInput: moment(membership.validTill).format("YYYY-MM-DD"),
        };
      } else {
        this.editingMembership = this.emptyMembership();
      }
      this.showMembershipForm = true;
    },
    cancelMembershipForm() {
      this.showMembershipForm = false;
      this.editingMembership = this.emptyMembership();
      this.membershipFormError = null;
      this.membershipFormSuccess = null;
    },
    saveProfile() {
      this.savingProfile = true;
      this.profileError = null;
      this.profileSuccess = null;

      const payload = Object.assign({}, this.profileForm);
      payload.birthDate = this.profileBirthDate;
      payload.industryVertical = parseInt(payload.industryVertical) || 0;

      axios
        .post("/api/User/AdminSaveUser", payload)
        .then(() => {
          this.profileSuccess = "Profile saved successfully!";
          this.savingProfile = false;
          this.$emit("saved");
        })
        .catch((error) => {
          this.savingProfile = false;
          if (error.response && error.response.data) {
            const data = error.response.data;
            this.profileError = Array.isArray(data) ? data.join(" ") : data;
          } else {
            this.profileError = "An error occurred. Please try again.";
          }
        });
    },
    saveMembership() {
      this.savingMembership = true;
      this.membershipFormError = null;
      this.membershipFormSuccess = null;

      const payload = {
        membershipId: this.editingMembership.membershipId || 0,
        userId: this.profileForm.userId,
        membershipType: parseInt(this.editingMembership.membershipType) || 0,
        membershipStatus: this.editingMembership.membershipStatus,
        validFrom: this.editingMembership.validFromInput,
        validTill: this.editingMembership.validTillInput,
        transactionDetailInformation: {
          gatewayTransactionInfo: {
            amountPaid: 0,
            paymentId: "NA",
            signature: "NA",
            paymentOrderId: "NA",
            transactionType: 3,
          },
        },
      };

      axios
        .post("/api/Membership/AdminSaveMembership", payload)
        .then(() => {
          this.membershipFormSuccess = "Membership saved successfully!";
          this.savingMembership = false;
          this.membershipsLoaded = false;
          this.loadMemberships();
          this.$emit("saved");
          setTimeout(() => {
            this.showMembershipForm = false;
            this.membershipFormSuccess = null;
          }, 1200);
        })
        .catch((error) => {
          this.savingMembership = false;
          if (error.response && error.response.data) {
            const data = error.response.data;
            this.membershipFormError = Array.isArray(data) ? data.join(" ") : data;
          } else {
            this.membershipFormError = "An error occurred. Please try again.";
          }
        });
    },
  },
};
</script>

<style scoped>
.overlay {
  border-radius: 0.25rem;
  align-items: center;
  background: rgba(255, 255, 255, 0.7);
  display: flex;
  justify-content: center;
  z-index: 9999;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}
</style>
